import React from "react";
import Input from "../../../../component/common/Input";
import Textarea from "../../../../component/common/TextArea";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import httpServices from "../../../../services/httpServices";
const schema = yup.object().shape({
  surveyName: yup
    .string()
    .required("Survey Name is required")
    .min(3, "Survey Name must be at least 3 characters long"),
  surveyDescription: yup
    .string()
    .required("Description is required")
    .max(100, "Description cannot exceed 100 characters"),
});

const SignleEventSurvey = () => {
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const { response, error } = await httpServices.post(
        `/eventSurveyDetails/create`,
        {
          ...data,
          eventId: id,
        }
      );
      if (error) {
        throw error;
      }
      if (response.status === 201) {
        toast.success("Survey created successfully");
      }
    } catch (error) {}
    console.log("Data", data);
  };
  return (
    <div className="border-t border-t-[#C1CAE1] mt-[20px] pt-[15px]">
      <h1 className="gradient-text font-medium text-lg">Create Survey</h1>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col items-center pt-[30px]"
      >
        <div>
          <label
            className={`mb-2 text-sm lg:text-[16px] font-medium text-black block`}
          >
            Survey Name*
          </label>
          <Input
            classes="w-[697px]"
            {...register("surveyName")}
            placeholder={"Enter survey name"}
            inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] placeholder:text-[#06152B] text-[#06152B]"
          />
          {errors.surveyName && (
            <p className="text-red-500 text-sm">{errors.surveyName.message}</p>
          )}
        </div>
        <div className="w-[697px] mt-[16px] relative pb-[20px] border-b border-b-[#C1CAE1]">
          <label
            className={`mb-2 text-sm lg:text-[16px] font-medium text-black block`}
          >
            Describe your event
          </label>
          <textarea
            name="surveyDescription"
            {...register("surveyDescription")}
            placeholder="Add survey description"
            className={`pr-4 pl-5 py-3 text-black rounded bg-[#F5F6FA]  w-full placeholder:text-500-gray text-sm focus:outline-none h-[150px] md:h-[109px]`}
          />

          {errors.surveyDescription && (
            <p className="text-red-500 text-sm">
              {errors.surveyDescription.message}
            </p>
          )}
        </div>
        <div className="flex justify-center mt-[40px] mb-[30px]">
          <button
            type="submit"
            className="text-white px-[110px] py-2 bg-gradient-to-t from-[#2E3E8D] to-[#4DB1E1]"
          >
            Save & Proceed
          </button>
        </div>
      </form>
    </div>
  );
};

export default SignleEventSurvey;
